import React from "react"

import DiscountsSwiper from "../DiscountsSwiper"

import * as styles from "./discounts.module.scss"

type DiscountsProps = {
  orderNum?: string
}

export default function Discounts({ orderNum }: DiscountsProps) {
  return (
    <section className={styles.root} data-exclude={orderNum}>
      <h2 className={styles.head}>Акции и скидки</h2>
      <DiscountsSwiper />
    </section>
  )
}
